export const APISettings={
    baseURL:process.env.VUE_APP_API_URL,
}